import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Instagram(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M7.5 4A3.502 3.502 0 004 7.5v9C4 18.432 5.568 20 7.5 20h9c1.932 0 3.5-1.568 3.5-3.5v-9C20 5.568 18.432 4 16.5 4h-9zM2 7.5C2 4.464 4.464 2 7.5 2h9C19.536 2 22 4.464 22 7.5v9c0 3.036-2.464 5.5-5.5 5.5h-9A5.502 5.502 0 012 16.5v-9zm10.434 1.533a2.826 2.826 0 00-.866 0l-.007.002a2.99 2.99 0 00-2.527 3.402v.005a2.992 2.992 0 003.408 2.525 2.992 2.992 0 002.526-3.405 3.01 3.01 0 00-2.53-2.528h-.004zm.302-1.977a4.825 4.825 0 00-1.468 0 4.99 4.99 0 00-4.212 5.677 4.992 4.992 0 005.675 4.213 4.992 4.992 0 004.216-5.675l-.001-.003a5.01 5.01 0 00-4.21-4.212zM17 8a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  }));
}

export default Instagram;